import React from 'react';
import { useNavigate } from 'react-router-dom';
import RoleManager from './RoleManager';
import './RoleManagerPage.css';

const RoleManagerPage = () => {
  const navigate = useNavigate();

  return (
    <div className="role-manager-page">
      <div className="role-manager-page-header">
        <button className="role-manager-back-button" onClick={() => navigate('/settings')}>← Back to Settings</button>
      </div>
      <RoleManager />
    </div>
  );
};

export default RoleManagerPage;
